import { render, staticRenderFns } from "./AddSoNewCust.vue?vue&type=template&id=6c7d7bd4&scoped=true&"
import script from "./AddSoNewCust.vue?vue&type=script&lang=js&"
export * from "./AddSoNewCust.vue?vue&type=script&lang=js&"
import style0 from "./AddSoNewCust.vue?vue&type=style&index=0&id=6c7d7bd4&lang=scss&"
import style1 from "./AddSoNewCust.vue?vue&type=style&index=1&id=6c7d7bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7d7bd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c7d7bd4')) {
      api.createRecord('6c7d7bd4', component.options)
    } else {
      api.reload('6c7d7bd4', component.options)
    }
    module.hot.accept("./AddSoNewCust.vue?vue&type=template&id=6c7d7bd4&scoped=true&", function () {
      api.rerender('6c7d7bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/salesorder/AddSoNewCust.vue"
export default component.exports